import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Action } from "../../../components/ui/Action";
import { useNavigate } from "react-router-dom";
import { formatMoney } from "../../../hooks/formatMoney";
import i18next from "i18next";

const IncomesListItem = ({ index, item, refreshHandler, tenant, taxTypeById }) => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const date = new Date(item?.incomes_date);

  const formatted = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Riyadh",
  }).format(date);

  const goToEditReadOnly = () => {
    navigate(`/${tenant}/incomes/edit/${item.id}?readonly=1`);
  };

  const validTaxes = useMemo(() => {
    if (!item?.details?.length) return [];
    const map = taxTypeById || {};
    return (
      item.details
        ?.map((detail) => {
          const tax = map[String(detail?.tax_type)];
          if (!tax) return null;
          return {
            label: String(tax.label || "").trim(),
            value: Number(tax.value),
          };
        })
        .filter(Boolean)
        .filter((tax, _, all) => {
          if (all.length === 1) return true;
          return tax.value > 0;
        })
        .map((tax) => tax.label) || []
    );
  }, [item, taxTypeById]);

  if (!item) return null;
  const noTaxLabel = i18next.language === "ar" ? "لا يوجد" : "None";

  return (
    <div className="divide-y w-full relative bg-[#fff] divide-slate-200">
      <div
        onClick={goToEditReadOnly}
        key={index}
        className="flex w-full border-b border-[#ddd0bf] border-opacity-35 hover:bg-[#f5f8f1] transition cursor-pointer hover:text-black gap-1 items-center py-0.5 px-1 text-[#251658] text-sm"
      >
        <div className="w-[110px] shrink-0 text-start ps-2">{item?.code}</div>
        <div className="flex-[1.6] min-w-[280px] text-start">
          {item?.desc
            ? `${item?.desc.slice(0, 95)}...`
            : t("Salaries.nonbondDescription")}
        </div>
        <div className="w-[135px] shrink-0 text-center">
          {formatMoney(item?.total_amount)} {t("Salaries.currency")}
        </div>

        <div
          className={`flex-[1.1] min-w-[220px] text-center leading-4 whitespace-pre-line ${
            validTaxes.length === 1 ? "text-[13px]" : "text-[11px]"
          }`}
        >
          {validTaxes.length > 0 ? (
            validTaxes.map((label, i) => <div key={i}>{label}</div>)
          ) : (
            noTaxLabel
          )}
        </div>

        <div className="w-[95px] shrink-0 text-center">
          {formatMoney(item?.vat_amount)} {t("Salaries.currency")}
        </div>
        <div className="w-[135px] shrink-0 text-center">
          {formatMoney(item?.total_amount_with_vat)} {t("Salaries.currency")}
        </div>
        <div className="w-[122px] shrink-0 text-center">{formatted}</div>
        <div
          onClick={(e) => e.stopPropagation()}
          className="w-[96px] shrink-0 p-0 text-center text-[12px] rounded-md"
        >
          <Action
            id={item.id}
            item1=""
            path1={`/incomes/show`}
            path2={`/incomes/edit`}
            item2=""
            item3=""
            icon1={"/assets/icons/Print.png"}
            icon2={"/assets/icons/Edit.png"}
            icon3={"/assets/icons/Trash.png"}
            refreshHandler={refreshHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default IncomesListItem;
